import UiLibView from '@/views/UiLibView.vue';

export const uiLib = () => [
  {
    path: '/ui-lib',
    name: 'ui-lib',
    component: UiLibView,
    meta: {
      authStateRequired: 'either',
      title: 'Component Library',
    },
  },
];
